"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/popover/style/css");

var _popover = _interopRequireDefault(require("antd/es/popover"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _reactRouterDom = require("react-router-dom");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

require("./username.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class Username extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {};

    this.renderPopover = () => {
      const {
        participantId,
        participants,
        studyArms
      } = this.props;
      const currentParticipant = participants === null || participants === void 0 ? void 0 : participants.find(p => p.id === participantId);
      const currentStudyArm = studyArms === null || studyArms === void 0 ? void 0 : studyArms.find(sa => sa.id === (currentParticipant === null || currentParticipant === void 0 ? void 0 : currentParticipant.studyArmId));

      if (!currentParticipant) {
        if (this.props.username) {
          return /*#__PURE__*/_react.default.createElement("span", null, this.props.username);
        }

        return /*#__PURE__*/_react.default.createElement("span", null, "No Participant Found.");
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "username-popover"
      }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("b", null, "ID:"), ' ', currentParticipant.id), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("b", null, "Name:"), ' ', `${currentParticipant.firstName} ${currentParticipant.lastName}`), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("b", null, "Study Arm:"), ' ', currentStudyArm === null || currentStudyArm === void 0 ? void 0 : currentStudyArm.name), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("b", null, "Mobile:"), " ", currentParticipant.mobile));
    };
  }

  render() {
    var _a;

    const {
      participantId,
      participants,
      style,
      studyId,
      link
    } = this.props;
    const currentParticipant = participants === null || participants === void 0 ? void 0 : participants.find(p => p.id === participantId);

    if (!currentParticipant && !this.props.username) {
      return /*#__PURE__*/_react.default.createElement("span", null, "No Participant Found.");
    }

    const username = (_a = currentParticipant === null || currentParticipant === void 0 ? void 0 : currentParticipant.username) !== null && _a !== void 0 ? _a : this.props.username;
    return /*#__PURE__*/_react.default.createElement(_popover.default, {
      content: this.renderPopover()
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      style: style || {},
      to: link || `/study/${studyId}/participants/${participantId}`
    }, username));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  participants: selectors.getParticipants,
  studyArms: selectors.getStudyArms,
  studyId: selectors.getRequestedStudyId
});

var _default = (0, _reactRedux.connect)(mapStateToProps, null)(Username);

exports.default = _default;